export default (
  BASE_URL,
  KEYCLOCK_REALM_NAME,
  KEYCLOCK_CLIENT_ID,
  KEYCLOCK_SSO,
  KEYCLOCK_PORT,
  KEYCLOACK_URL_WITH_PORT,
  APP_URL
) => {
  return {
    KEYCLOCK_URL: `${KEYCLOACK_URL_WITH_PORT}`,
    KEYCLOCK_REALM_NAME,
    KEYCLOCK_CLIENT_ID,
    REDIRECT_URL: `${APP_URL}`,
    setHeader(token) {
      return {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': `${BASE_URL}`,
          'Content-type': 'application/json',
          'Accept-Version': 'v1',
        },
        crossdomain: true,
      };
    },
  };
};
